import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import Icon from "../../../system/components/icon";
import InputLabel from "../../../system/components/input-label";
import {useTranslate} from "../../../system/useTranslate";

function AddLinkDialog({ visible, setVisible, onSubmit }) {
    const translate = useTranslate();
    const [linkData, setLinkData] = useState({ title: '', url: '' });

// reset form in start

    useEffect(() => {
        if (visible) {
            setLinkData({ title: '', url: '' });
        }
    }, [visible]);

    const handleInvite = () => {
        if (linkData.title && linkData.url) {
            onSubmit?.(linkData);
            setVisible(false);
        }
    };

    return (
        <Dialog
            visible={visible}
            onHide={() => setVisible(false)}
            header={<Header />}
            footer={<Footer setVisible={setVisible} onSubmit={handleInvite} />}
            className="rtl w-full md:w-30rem border-round-2xl"
            pt={{
                root: { className: "border-round-2xl" },
                header: { className: "border-round-top-2xl pb-2" },
                content: { className: "p-4" },
                footer: { className: "p-0 border-round-bottom-2xl" }
            }}
        >
            <div className="flex flex-column gap-4">
                {/*  link title */}
                <InputLabel
                    label={translate("link-title")}
                    className="flex flex-column gap-2"
                >
                    <InputText
                        value={linkData.title}
                        onChange={(e) => setLinkData({ ...linkData, title: e.target.value })}
                        placeholder={translate("link-title-placeholder")} // مثلا: "راهنمای استفاده از API"
                        className="w-full text-sm p-3 border-round-xl"
                    />
                </InputLabel>

{/*link address*/}
                <InputLabel
                    label={translate("link-url")}
                    className="flex flex-column gap-2"
                >
                    <span className="p-input-icon-right">
                        <i className="mi mi:link text-400" />
                        <InputText
                            value={linkData.url}
                            dir="ltr"
                            onChange={(e) => setLinkData({ ...linkData, url: e.target.value })}
                            placeholder="https://example.com"
                            className="w-full text-sm p-3 border-round-xl"
                        />
                    </span>
                </InputLabel>

                {/*    warning info box */}
                <div className="flex align-items-start gap-2 p-3 border-round-xl bg-orange-50 border-1 border-orange-100">
                    <Icon icon="mi mi:info" className="text-orange-500 mt-1" />
                    <span className="text-xs text-700 line-height-3">
                        {translate("add-link-visibility-warning")}
                    </span>
                </div>
            </div>
        </Dialog>
    );
}

function Header() {
    const translate = useTranslate();
    return (
        <div className="flex align-items-center justify-content-center w-full pt-2">
            <span className="text-lg font-bold">{translate("add-link-to-documents")}</span>
        </div>
    );
}

function Footer({ setVisible, onSubmit }) {
    const translate = useTranslate();
    return (
        <div className="flex flex-row-reverse align-items-center gap-2 justify-content-start p-3 surface-50 border-round-bottom-2xl border-top-1 border-300">
            <Button
                label={translate("add-link-action")}
                className="text-sm bg-perimary border-none px-4 py-2 border-round-lg"
                onClick={onSubmit}
            />
            <Button
                label={translate("cancel")}
                className="text-xs p-button-secondary p-button-outlined border-round-lg p-2"
                onClick={() => setVisible(false)}
            />
        </div>
    );
}

export default AddLinkDialog;
